/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {TOGGLE_FULLSCREEN, TOGGLE_HOMING} from '../actions/display';

const defaultState = {
    fullscreen: false,
    homeState: true,
    icon: "home"
};

export default function toggleFullscreen(state = defaultState, action) {
    switch (action.type) {
    case TOGGLE_FULLSCREEN: {
        return {...state, fullscreen: action.fullscreen};
    } 
    case TOGGLE_HOMING: {
        return {...state, homeState: action.homeState, icon: action.icon};
    }
    default:
        return state;
    }
}
